import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Config } from "../../../@vendor/config/config";

@Injectable({
  providedIn: "root",
})
export class DepoitsService {
  constructor(private config: Config, private http: HttpClient) {}
  getOwnDeposits(): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/deposit/ownedDeposits`;
    return this.http.get(url, param);
  }
  getOwnDepositsInvestment(): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/deposit/ownedDepositsForFund`;
    return this.http.get(url, param);
  }
  getOwnDepositsForCacheCheque(): Observable<any> {
    const param = {};
    const url =
      this.config.serverUrl + `api/deposit/ownedDepositsForCashChecks`;
    return this.http.get(url, param);
  }
  getDestinationDeposits(): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/deposit/destinationDeposits`;
    return this.http.get(url, param);
  }
  getDestinationIbans(): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/iban/destinationIbans`;
    return this.http.get(url, param);
  }
  getDepositStatement(param, depositUniqueId): Observable<any> {
    const url =
      this.config.serverUrl + `api/deposit/${depositUniqueId}/statement`;
    return this.http.post(url, param);
  }
  getOwnLoans(): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/loan/`;
    return this.http.get(url, param);
  }
  getLoanInstallment(loanNumber): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/loan/${loanNumber}/installments`;
    return this.http.get(url, param);
  }
  payLoan(request, loanNumber): Observable<any> {
    const param = request;
    const url = this.config.serverUrl + `api/loan/pay/${loanNumber}`;
    return this.http.post(url, param);
  }
  sendDepositStatementEmail(requestObj, depositUniqueId): Observable<any> {
    const param = requestObj;
    const url =
      this.config.serverUrl + `api/deposit/${depositUniqueId}/statement/demand`;
    return this.http.post(url, param);
  }
  deleteDestinatioDeposit(depositUniqueId): Observable<any> {
    const url =
      this.config.serverUrl +
      `api/deposit/destinationDeposits/${depositUniqueId}`;
    return this.http.delete(url, {});
  }
  deleteDestinationIban(ibanUniqueId): Observable<any> {
    const url =
      this.config.serverUrl + `api/iban/destinationIbans/${ibanUniqueId}`;
    return this.http.delete(url, {});
  }
  editDestinatioDeposit(depositObj, depositUniqueId): Observable<any> {
    const url =
      this.config.serverUrl +
      `api/deposit/destinationDeposits/${depositUniqueId}`;
    return this.http.post(url, depositObj);
  }
  editDestinationIban(ibanObj, ibanUniqueId): Observable<any> {
    const url =
      this.config.serverUrl + `api/iban/destinationIbans/${ibanUniqueId}`;
    return this.http.post(url, ibanObj);
  }
  getAdvertisement(): Observable<any> {
    const url = this.config.serverUrl + `api/advertisement?type=PopUp`;
    return this.http.get(url, {});
  }
  seenAdvertisement(advertisementUniqueId): Observable<any> {
    const url =
      this.config.serverUrl + `api/advertisement/${advertisementUniqueId}/seen`;
    return this.http.post(url, {});
  }
  getAvailableActions(): Observable<any> {
    const url = this.config.serverUrl + `api/chakad/availableActions`;
    return this.http.get(url, {});
  }
  callMotamed(): Observable<any> {
    const url = this.config.serverUrl + `api/namatspTax`;
    return this.http.get(url, {});
  }
}
